import { ProgressBar } from 'react-bootstrap';
import LinkClicksChartHeader from './LinkClicksChartHeader';
import { useTranslation } from 'react-i18next';

const ClicksByCountry = ({ countries, otherClicks, totalClicks }) => {
  const { t } = useTranslation();
  const rows = otherClicks
    ? [
        ...countries,
        {
          country: t('linkClicks.otherCountries'),
          clicks: otherClicks,
          share: totalClicks
            ? Number(((otherClicks / totalClicks) * 100).toFixed(1))
            : 0
        }
      ]
    : countries;
  const maxClicks = Math.max(...rows.map(({ clicks }) => clicks), 1);

  return (
    <section className="bg-white rounded-4 p-3 p-md-4 h-100">
      <LinkClicksChartHeader
        title={t('linkClicks.clicksByCountry')}
        description={t('linkClicks.clicksByCountryDescription')}
      />
      <div>
        <div className="row g-2 align-items-center text-gray text-uppercase fs-9 mb-2">
          <div className="col-3">{t('linkClicks.country')}</div>
          <div className="col-6">{t('linkClicks.volume')}</div>
          <div className="col text-end">{t('linkClicks.clicks')}</div>
          <div className="col text-end">%</div>
        </div>
        <div className="d-flex flex-column gap-3">
          {rows.map(({ country, clicks, share }) => (
            <div key={country} className="row g-2 align-items-center fs-7">
              <div className="col-3 text-truncate">{country}</div>
              <div className="col-6">
                <ProgressBar
                  className="link-clicks-country-progress"
                  variant="primary2"
                  now={(clicks / maxClicks) * 100}
                  aria-label={`${country}: ${clicks} ${t('linkClicks.clicks')}`}
                />
              </div>
              <div className="col text-end fw-bold">{clicks}</div>
              <div className="col text-end">{share}%</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClicksByCountry;
